import { createBrowserRouter } from "react-router-dom";
import { Layout } from "./components/Layout";
import { CampaignDetails } from "./pages/campaign/CampaignDetails";
import { AudienceTargeting } from "./pages/campaign/AudienceTargeting";
import { Creative } from "./pages/campaign/Creative";
import { ContactInfo } from "./pages/campaign/ContactInfo";
import { CampaignOverview } from "./pages/campaign/CampaignOverview";
import { CampaignsList } from "./pages/campaign/CampaignsList";
import { SubmittedPage } from "./pages/campaign/SubmittedPage";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { CampaignView } from "./pages/campaign/CampaignView";
import { Profile } from "./pages/Profile";
import { RequireStepCompletion } from "./components/RequireStepCompletion";

console.log("Routes being registered:", {
	routes: [
		"/",
		"/login",
		"/register",
		"/campaigns/:id",
		"/profile",
		"/create",
		"/create/audience",
		"/create/creative",
		"/create/contact",
		"/create/overview",
		"/submitted",
	],
});

export const router = createBrowserRouter([
	{
		path: "/login",
		element: <Login />,
	},
	{
		path: "/register",
		element: <Register />,
	},
	{
		path: "/",
		element: (
			<ProtectedRoute>
				<Layout />
			</ProtectedRoute>
		),
		children: [
			{
				path: "/",
				element: <CampaignsList />,
			},
			{
				path: "/campaigns/:id",
				element: <CampaignView />,
			},
			{
				path: "/profile",
				element: <Profile />,
			},
			{
				path: "/create",
				children: [
					{
						path: "",
						element: <CampaignDetails />,
					},
					{
						path: "audience",
						element: (
							<RequireStepCompletion requiredStep="campaignDetails">
								<AudienceTargeting />
							</RequireStepCompletion>
						),
					},
					{
						path: "creative",
						element: (
							<RequireStepCompletion requiredStep="audienceTargeting">
								<Creative />
							</RequireStepCompletion>
						),
					},
					{
						path: "contact",
						element: (
							<RequireStepCompletion requiredStep="creativeFiles">
								<ContactInfo />
							</RequireStepCompletion>
						),
					},
					{
						path: "overview",
						element: (
							<RequireStepCompletion requiredStep="contactInfo">
								<CampaignOverview />
							</RequireStepCompletion>
						),
					},
				],
			},
			{
				path: "submitted",
				element: <SubmittedPage />,
			},
		],
	},
]);
